import React from 'react';
import './styles/NextButton.scss';

const NextButton = (): React.ReactElement => (
    <a className="next-button" href="https://triplex-design.ru/next/">
        <span className='parallelogram' > 
            <span className='square' > 
                <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.44922 1.44906L4.23868 5.48865L1.44922 9.52825" stroke="white" strokeWidth="2.08333" strokeLinecap="square"/>
                </svg>
            </span>
            <span className="text">go.next</span>
        </span>
    </a>
);

export default NextButton;